module.exports = __webpack_public_path__ + "img/travel_stage.3706422d.svg";